import { GANTT_GLOBAL_CONFIG } from '@worktile/gantt';
import { GanttDate } from '@worktile/gantt';
import { locale } from 'moment';

export const SPANISH_GANTT_CONFIG = {
  provide: GANTT_GLOBAL_CONFIG,
  useValue: {
    // Nombres de meses
    monthNames: [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ],
    
    // Abreviaturas de meses
    monthNamesAbbr: [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ],

    // Nombres de días de la semana
    weekNames: [
      'Domingo', 'Lunes', 'Martes', 'Miércoles', 
      'Jueves', 'Viernes', 'Sábado'
    ],
    
    // Abreviaturas de días
    weekNamesAbbr: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],

    dateFormat: {
      month: 'MMM MM',       // Mes abreviado (Ene, Feb, etc.)
      yearMonth: 'MMM yyyy', // Mes y año (Ene 2023)
      week: 'w',          // Número de semana
      day: 'd',           // Día del mes
      year: 'yyyy',       // Año completo
      monthDay: 'd MMM',   // Día y mes (5 Ene)
      yearQuarter: 'yyyy', // Año y trimestre (2023)
    },

    // Textos de la interfaz
    texts: {
      today: 'Hoy',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      quarter: 'Trimestre',
      year: 'Año',
      task: 'Tarea',
      tasks: 'Tareas',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      expandAll: 'Expandir todo',
      collapseAll: 'Colapsar todo',
      exportToPDF: 'Exportar a PDF'
    },
  }
};